import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

import { i18n } from '@/plugins/i18n'

@Mixin
export default class I18NMixin extends Vue {
    getTranslation(str: string, params?: any) {
        return i18n.t(str, params)
    }

    getComplexTranslations(str: string, params?: any) {
        let group = str.split('.')[0]
        let tstr = str.split('.').slice(1).join('.')

        let translationObject: any = this.$t(group)

        let translation: any = ''

        if (typeof translationObject == 'object') {
            translation = translationObject[tstr] ? translationObject[tstr] : tstr
        }

        // fall back to original translate key if there's no value for it
        return translation ? translation : str
    }
}
